<template lang="html">
  <div class="video">
    <div class="content" v-if="videoList.length > 0">
      <div v-for="a in videoList.slice(0, 19)" :key="a.unique_id" class="videoList" :style="{backgroundImage: 'url('+ a.pic +')'}" @click="goFilm(a.unique_id, a.type)">
        <img src="../../../assets/image/icon/videoTop.png" alt="" class="videoTop" v-show="a.is_recommend">
        <div class="videoNum">
          <img src="../../../assets/image/icon/play.png" alt="" class="playIcon">
          {{a.hitnum}}
        </div>
      </div>
    </div>
    <div class="noInfo" v-else>
      <div>
        <img :src="`${pagebase}/static/img/elecom/video.png`" alt="">
      </div>
      <p>还没有任何视频内容哦</p>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http'

  export default {
    props: ['userId'],

    data() {
      return {
        videoList: [],
        pagebase: pagebase,
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getVideoList();
      },

      getVideoList() {
        this.$http({
          url: '/eleom/myShortvideoList',
          method: 'get',
          params: {
            page: 1,
            uid: this.userId,
            master_id: this.userId,
            limit: 20,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.videoList = res.data;
          }
        })
      },

      goFilm(id, type) {
        sessionStorage.setItem('cur', 1);
        this.$router.push({
          path: '/cFilm',
          query: {
            id: id,
            type: type,
          }
        })
      },
    },
  }
</script>

<style lang="css" scoped>
  .video {}

  .content {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    padding: 1.5rem 1.1rem 1.5rem 1.5rem;
  }

  .videoList {
    position: relative;
    box-sizing: border-box;
    width: 11rem;
    height: 14.8rem;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: flex-end;
    font-size: 1.2rem;
    color: #FFFFFF;
    margin-right: .62rem;
    margin-bottom: .8rem;
  }

  .videoTop {
    position: absolute;
    top: .6rem;
    left: .6rem;
    width: 2.8rem;
  }

  .videoNum {
    box-sizing: border-box;
    width: 100%;
    height: 50%;
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
    display: flex;
    align-items: flex-end;
    text-align: center;
    object-fit: cover;
    padding-bottom: .7rem;
    padding-left: .7rem;
  }

  .playIcon {
    width: 1.6rem;
    height: 1.6rem;
    margin-right: .5rem;
  }

  .noInfo {
    height: 37.5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }

  .noInfo img {
    width: 19.5rem;
    height: 19.5rem;
  }

  .noInfo p {
    font-size: 1.4rem;
    color: #9CA3A9;
  }
</style>
